module.exports = __webpack_public_path__ + "static/media/dota2.3d8d01d9.jpg";